import React, { useState, useContext, useEffect } from "react"
import { articleContext } from "../../providers/article/article.provider"
import {
  pipe,
  sortArticleByItsItem,
  filterLabelArticle,
  filterArticleWithNumber,
} from "../../providers/article/article.utils"
import { Container, Wrap, LabelArea, Label } from "./popularArticle.style"
import HomePageTitle from "../homePageTitle/homePageTitle"
import ArticleList1 from "../articleList1/articleList1"
import { LABEL_MAP } from "../../providers/article/articleLabel.data"

const PopularArticle = () => {
  const { articleDatas, labelArr } = useContext(articleContext)

  const initArticles = pipe(
    sortArticleByItsItem(`views`),
    filterArticleWithNumber(3)
  )(articleDatas)

  const [articles, setArticles] = useState(initArticles)
  const [selectedLabel, setSelectedLabel] = useState(0)
  const [theLabelArr, setTheLabelArr] = useState([])

  useEffect(() => {
    const labelDataArr = articleDatas.map(article => article.label)
    const uniqueLabelArr = [0, ...new Set(labelDataArr)]
    const labelArr = uniqueLabelArr.map(item => ({
      key: item,
      value: LABEL_MAP.get(item),
    }))
    setTheLabelArr(labelArr)
  }, [])

  useEffect(() => {
    setArticles(
      pipe(
        sortArticleByItsItem(`views`),
        filterLabelArticle(selectedLabel),
        filterArticleWithNumber(3)
      )(articleDatas)
    )
  }, [selectedLabel, articleDatas])

  const handleLabelOnClick = e => {
    const label = parseInt(e.target.value)
    setSelectedLabel(label)
  }

  return (
    <Container>
      <HomePageTitle>Popular Articles</HomePageTitle>
      <Wrap>
        <LabelArea>
          {theLabelArr && theLabelArr.length> 0 && theLabelArr.map(({ key, value: { name, color, gradientColor } }) => {
            const isSelected = selectedLabel === key
            return (
              <Label
                key={key}
                value={key}
                onClick={handleLabelOnClick}
                color={color}
                gradientColor={gradientColor}
                isSelected={isSelected}
              >
                {name}
              </Label>
            )
          })}
        </LabelArea>
        <ArticleList1 articles={articles} />
      </Wrap>
    </Container>
  )
}

export default PopularArticle
